import React, {useState, useEffect} from 'react';
import styled from 'styled-components'
import ReactDOM from 'react-dom';
import ReactTooltip from "react-tooltip";
import {trackGaussEvent} from "../helper/analytics";

export default function SearchCourse() {

    const [isFavouriteFilter, setIsFavouriteFilter] = useState(false)
    const [isAlreadySeenFilter, setIsAlreadySeenFilter] = useState(false)

    const [isActiveOnMenu, setIsActiveOnMenu] = useState(false)

    useEffect(() => {
        const listener = (event) => {
            const menuitem = event.detail
            setIsActiveOnMenu(menuitem === 'video')
        }

        document.addEventListener('course_menu_tabs', listener)

        return () => {
            document.removeEventListener('course_menu_tabs', listener)
        }

    }, []);

    const switchFavourite = () => {
        setIsFavouriteFilter(!isFavouriteFilter)
        const event = new Event('course_filter_favourites');
        document.dispatchEvent(event)
    }

    const switchIsAlreadySeen = () => {
        setIsAlreadySeenFilter(!isAlreadySeenFilter)
        const event = new Event('course_filter_already_seen');
        document.dispatchEvent(event)
    }

    let timeout = null
    const onChangeInput = (event) => {
        const value = event.target.value
        const e = new CustomEvent('course_filter_query', {detail: value});
        document.dispatchEvent(e)

        if(timeout) clearTimeout(timeout)

        timeout = setTimeout(() => {
            if(value.length > 0) {
                trackGaussEvent('search_on_course', {
                    url: window.location.href,
                    query: value

                })
            }

        }, 500)
    }

    if(!isActiveOnMenu) return null;

    return (
        <Container>
            <ReactTooltip id='eye' type='dark'>
                <span>Marca tus videos como vistos</span>
            </ReactTooltip>

            <ReactTooltip id='star' type='dark'>
                <span>Marca tus videos como favoritos</span>
            </ReactTooltip>
            <InputText onChange={onChangeInput} type='text' placeholder={'Buscar'} />
            <Buttons>
                <ImageFilter data-tip data-for="star"  onClick={switchFavourite} src={`https://d2wl56ig1uoitb.cloudfront.net/images/${!isFavouriteFilter ? 'star.svg' : 'star_fill.svg'}`} />
                <ImageFilter data-tip data-for="eye"  onClick={switchIsAlreadySeen} src={`https://d2wl56ig1uoitb.cloudfront.net/images/${!isAlreadySeenFilter ? 'eye.svg' : 'eye_fill.svg'}`} />
            </Buttons>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-top: 14px;
`

const InputText = styled.input`
    width: 250px;
    padding: 8px 12px;
    margin-left: 12px;
    font-size: 12px;
`

const Buttons = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    flex: 1;
    padding-top: 4px;
`

const ImageFilter = styled.img`
    width: 30px;
    height: 30px;
    cursor: pointer;
`


if (document.getElementsByTagName('course-tool-menu')) {
    const elms = document.getElementsByTagName('course-tool-menu')

    for(let elm of elms) {
        ReactDOM.render(<SearchCourse />, elm);
    }
}
